import { __awaiter } from "tslib";
import { RestService } from '../rest';
const rest = new RestService();
export const setJwt = (token) => {
    rest.setToken(token);
};
export const updatePhone = (phone) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield rest.put(`/api/kcas/profile/profile/update-phone`, phone, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    }
    catch (error) {
        return false;
    }
});
export const confirmEmailChange = (nonce) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield rest.post(`/api/kcas/profile/profile/update-email/${nonce}`);
        return true;
    }
    catch (error) {
        return false;
    }
});
export const addProfileConnection = (token) => __awaiter(void 0, void 0, void 0, function* () {
    yield rest.post(`/api/kcas/profile/add-connection/${token}`);
});
